import * as IF from "infrontjs";
import { AuthState } from "../base/AuthState";
import { initHeroShader, destroyHeroShader } from '../../components/hero-shader';

import template from './ForgotPasswordTemplate.html';

export class ForgotPasswordState extends AuthState
{
    static ROUTE = '/forgot-password';
    static ID = 'forgot-password';

    async enter()
    {
        const mainWrapper = this.app.container.querySelector( '#main-wrapper' );
        this.app.view.render(
            mainWrapper,
            template
        );

        initHeroShader( mainWrapper.querySelector( '#hero-shader' ) );

        // Pre-select saved region
        const savedRegion = this.app.storage.loadRegion();
        if ( savedRegion )
        {
            mainWrapper.querySelector( '[data-id="select-region"]' ).value = savedRegion;
        }

        this.addEventListener(
            mainWrapper.querySelector( '[data-id="btn-forgot-password"]' ),
            'click',
            async ( e ) => {
                mainWrapper.querySelector( '[data-id="forgot-password-error-container"]' ).style.display = 'none';
                const form = mainWrapper.querySelector( '[data-id="form-forgot-password"]' );
                if ( true === form.checkValidity() )
                {
                    mainWrapper.querySelector( '[data-id="btn-forgot-password"]' ).style.display = 'none';
                    mainWrapper.querySelector( '[data-id="btn-forgot-password-loading"]' ).style.display = 'block';
                    const formData = IF.Helper.serializeForm( form );

                    // Save region and update API endpoint
                    this.app.storage.saveRegion( formData.region );
                    this.app.api.setRegion( formData.region );

                    try
                    {
                        await this.app.api.post(
                            '/auth/password-reset',
                            {
                                email: formData.email
                            }
                        );

                        mainWrapper.querySelector( '[data-id="forgot-password-form-container"]' ).style.display = 'none';
                        mainWrapper.querySelector( '[data-id="forgot-password-success-container"]' ).style.display = 'block';
                    }
                    catch( e )
                    {
                        mainWrapper.querySelector( '[data-id="forgot-password-error-container"]' ).innerText = 'Something went wrong. Please try again later.';
                        mainWrapper.querySelector( '[data-id="forgot-password-error-container"]' ).style.display = 'block';
                    }
                    mainWrapper.querySelector( '[data-id="btn-forgot-password-loading"]' ).style.display = 'none';
                    mainWrapper.querySelector( '[data-id="btn-forgot-password"]' ).style.display = 'block';
                }
                else
                {
                    form.classList.add( 'was-validated' );
                }
            }
        );
    }

    async exit()
    {
        destroyHeroShader();
        const mainWrapper = this.app.container.querySelector( '#main-wrapper' );
        mainWrapper.querySelector( '[data-id="forgot-password-form-container"]' ).style.display = 'block';
        mainWrapper.querySelector( '[data-id="forgot-password-success-container"]' ).style.display = 'none';
    }
}
